import React from "react";

export default function MySQL_RTRIM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_RTRIM</h1>
      <p>This is the MySQL_RTRIM component generated from the SQL JSON.</p>
    </div>
  );
}
